export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-1440w.e55f6ae7.webp";